import React, { Component } from 'react';
import "./grid-item.css";

class GridItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: props.name,
            type: props.type,
            link: props.link,
            description: props.description
        }
    }

    setClass() {
        return "grid-item " + this.state.type;
    }

    setAlt(type) {
        return this.props.name + " " + type + " | Surfside Solutions Portfolio"
    }

    setPath(type) {
        // Change this from localhost when live
        return "https://cdn.jwjb.io/surfside/portfolio/" + type + "/" + this.props.name.toLowerCase().replace(/ /g,"") + ".png";
    }

    render() {
        return (
            <a href={this.props.link} target="_blank">
                <div className={this.setClass()}>
                    <img className="logo" src={this.setPath("logo")} alt={this.setAlt("Logo")} />
                    <img className="view" src={this.setPath("view")} alt={this.setAlt("View")} />
                    <h5 className="name">{this.state.name}</h5>
                </div>
            </a>
        );
    }
}

  export default GridItem;


// WEBPACK FOOTER //
// ./src/components/portfolio/grid-item/grid-item.js